import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  encryptEmployeeCode,
  loginSSO,
} from '../../services/Login/auth.service';

import { saveSsoLogin } from '../../utils/Login/authStorage';

const useSsoLogin = () => {
  const navigate = useNavigate();

  const [showSSO, setShowSSO] =
    useState(false);

  const [
    ssoEmployeeCode,
    setSsoEmployeeCode,
  ] = useState('');

  const [ssoLoading, setSsoLoading] =
    useState(false);

  const [error, setError] =
    useState('');

  const handleSSOLogin =
    async () => {
      try {
        setError('');
        setSsoLoading(true);

        const encryptedId =
          await encryptEmployeeCode(
            ssoEmployeeCode
          );

        const response =
          await loginSSO(
            encryptedId
          );

        saveSsoLogin(response);

        const role =
          response.roles?.[0]
            ?.roleName ??
          'Employee';

        navigate(
          role === 'Employee'
            ? '/employee-dashboard'
            : '/',
          {
            replace: true,
          }
        );
      } catch (err) {
        console.error(err);

        setError(
          'SSO Login Failed'
        );
      } finally {
        setSsoLoading(false);
      }
    };

  return {
    showSSO,
    setShowSSO,

    ssoEmployeeCode,
    setSsoEmployeeCode,

    ssoLoading,
    error,

    handleSSOLogin,
  };
};

export default useSsoLogin;